import React, { useState, useEffect } from 'react';
import { OIDCClient } from 'infrastructure/oidc/OIDCClient';
import { cancellable } from 'services/utility/cancellable';
import { useAuthorizationState } from './useAuthorizationState';
import { useLocation } from 'react-router';
import { useSessionStorageForOIDCTokenSet } from './useSessionStorageForOIDCTokenSet';

function useSignOutUrl(oidcClient: OIDCClient, forwardUrl: string, rewindUrl: string) {
    const { setAuthState } = useAuthorizationState();
    const [url, setUrl] = useState<string>();
    const { storeTokenSet } = useSessionStorageForOIDCTokenSet();

    useEffect(() => {
        return cancellable(async isCanceled => {
            const { endSessionUrl, state, willCallback } = await oidcClient.buildEndSessionUrl();
            if (isCanceled()) return;
            if (!willCallback) storeTokenSet(null);
            setAuthState({ type: 'END_SESSION', state, forwardUrl, rewindUrl });
            setUrl(endSessionUrl);
        });
    }, [forwardUrl, oidcClient, rewindUrl, setAuthState, storeTokenSet]);

    return url;
}

export type SignOutRequestProps = {
    oidcClient: OIDCClient;
    forwardUrl: string;
}

export const SignOutRequest = (props: SignOutRequestProps) => {
    const location = useLocation();
    const url = useSignOutUrl(props.oidcClient, props.forwardUrl, location.pathname);

    useEffect(() => {
        if (!url) return;
        window.location.href = url;
    }, [url]);

    return (
        <a href={url}>Redirecting...</a>
    );
};
